<template>
  <span>
    <a-button icon="filter" @click="visible = true">Filter</a-button>
    <a-drawer
      title="Filter list"
      placement="right"
      :visible="visible"
      @close="() => (visible = false)"
      :width="450"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <a-form-model
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        ref="ruleForm"
      >
        <a-form-model-item label="Branch location / Chi nhánh">
          <SelectBranchLocation
            v-model="filter.locationIds"
            :selectProps="{
              placeholder: 'Select location',
              mode: 'multiple',
              style: 'width: 100%',
              value: filter.locationIds,
            }"
          />
        </a-form-model-item>
        <a-form-model-item label="Driver / Tài xế">
          <SelectEmployee
            v-model="filter.driverEmployeeIds"
            :select-props="{
              mode: 'multiple',
              placeholder: 'Choose employee',
              value: filter.driverEmployeeIds,
            }"
          />
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button style="margin-right: 10px;" @click="visible = false">
          Close
        </a-button>
        <a-button type="primary" icon="filter" @click="onFilter">
          Filter
        </a-button>
      </div>
    </a-drawer>
  </span>
</template>

<script>
export default {
  components: {
    SelectBranchLocation: () =>
      import("@/components/common/branchLocation/select"),
    SelectEmployee: () => import("@/components/common/employee/select"),
  },
  props: {
    filterList: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      filter: {},
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
    };
  },
  methods: {
    onFilter() {
      this.filterList(this.filter);
      this.visible = false;
    },
  },
};
</script>
